import type { StationTask } from '@ordr-as/ordr-service-types/epos';
import EmptyState from '../EmptyState';
import BoardGrid from './BoardGrid';
import TaskCard from './TaskCard';

type Props = {
  tasks: StationTask[];
  stationName: string;
  stationNameById: Map<number, string>;
  selectedGroupId: string | null;
  focusedCardId: string | null;
  pendingTaskIds: Set<number>;
  onOpenDetail: (groupId: string) => void;
  onStart: (taskId: number) => void;
  onDone: (taskId: number) => void;
};

const StationBoard = ({
  tasks,
  stationName,
  stationNameById,
  selectedGroupId,
  focusedCardId,
  pendingTaskIds,
  onOpenDetail,
  onStart,
  onDone,
}: Props) => {
  if (tasks.length === 0) return <EmptyState label={stationName} />;

  return (
    <BoardGrid>
      {tasks.map((task) => (
        <TaskCard
          key={task.id}
          task={task}
          waitingForName={
            typeof task.waitingForStationId === 'number' ? stationNameById.get(task.waitingForStationId) : undefined
          }
          selected={selectedGroupId !== null && task.groupId === selectedGroupId}
          focused={String(task.id) === focusedCardId}
          mutating={pendingTaskIds.has(task.id)}
          onOpen={() => task.groupId && onOpenDetail(task.groupId)}
          onStart={() => onStart(task.id)}
          onDone={() => onDone(task.id)}
        />
      ))}
    </BoardGrid>
  );
};

export default StationBoard;
